import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { useFormikContext } from 'formik';

import { type PrescriberListPrescriber } from 'api/auctionsAPI';

interface DeletePrescriberDialogProps {
    prescriberToDelete?: PrescriberListPrescriber;
    onClose: () => void;
}

export const DeletePrescriberDialog = ({
    prescriberToDelete = undefined,
    onClose,
}: DeletePrescriberDialogProps) => {
    const formik = useFormikContext<{ prescribers?: PrescriberListPrescriber[] }>();
    return (
        <WarningDialog
            dialogTitle="Confirm Delete Prescriber"
            isOpen={!!prescriberToDelete}
            primaryButtonLabel="Yes, Delete Prescriber"
            primaryButtonIntent={Button.Intent.DANGER}
            onPrimaryButtonClick={() => {
                void (async () => {
                    await formik.setFieldValue(
                        'prescribers',
                        formik.values.prescribers?.filter(
                            ({ npi }) => npi !== prescriberToDelete?.npi,
                        ),
                    );
                    onClose();
                })();
            }}
            secondaryButtonLabel="No, Return To Prescriber List Details"
            onSecondaryButtonClick={onClose}
            width={520}
            dialogContent={
                <>
                    <div className="margin__bottom--large">
                        Are you sure you want to delete the following prescriber?
                    </div>
                    <div className="margin__bottom--large font-semi-bold">{`${prescriberToDelete?.name} - ${prescriberToDelete?.npi}`}</div>
                </>
            }
        />
    );
};
